export default __webpack_public_path__ + "static/media/ARU_Logo.5a2ab3ce.png";